<script>
import groupBy from 'lodash/groupBy';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';

import FloatLabel from './FloatLabel';

import './stylesheets/components/VsSelect';
import './stylesheets/components/VsInput';

export default {
  components: {
    FloatLabel,
  },
  props: {
    placeholder: String,
    value: [String, Number, Object],
    options: [Array, Object],
    large: [String, Boolean],
    disabled: [String, Boolean],
    keyValue: [String, Boolean],
    error: [String, Boolean],
    keyProperty: String,
    valueProperty: String,
    fullWidth: [String, Boolean],
    white: [String, Boolean],
    defaultValue: String,
    defaultText: String,
    grouped: [String, Boolean],
    allowEmptyString: [String, Boolean],
    errorId: String,
    pregroupedOptions: [Array, Object],
    labelId: String,
    preventAutofill: [String, Boolean],
    hideLabel: [Boolean, String],
  },
  data: () => ({
    focused: false,
  }),
  computed: {
    showDefaultValue() {
      if (this.allowEmptyString) {
        return (isUndefined(this.value) || isNull(this.value)) && this.defaultValue;
      } else {
        return (isUndefined(this.value) || isNull(this.value) || this.value === '') && this.defaultValue;
      }
    },
    showPlaceholder() {
      if (this.allowEmptyString) {
        return (isUndefined(this.value) || isNull(this.value));
      } else {
        return (isUndefined(this.value) || isNull(this.value) || this.value === '');
      }
    },
    groupedOptions() {
      return this.pregroupedOptions || groupBy(this.options, 'group');
    },
    classes() {
      return {
        'vs-input--large': this.large,
        'vs-input--error': this.error,
        'vs-input--white': this.white,
        'vs-input--full-width': this.fullWidth,
        'vs-select--placeholder': this.showPlaceholder,
        'floatl__input': !this.hideLabel,
      };
    },
    readonly() {
      return !this.focused && this.preventAutofill;
    },
  },
  methods: {
    updateFocus(value) {
      this.focused = value;
    },
  },
};
</script>

<template lang='pug'>
float-label(
  :placeholder='showDefaultValue ? defaultText : placeholder',
  :value='value',
  :full-width='fullWidth',
  :large='large',
  :hide-label='hideLabel',
)
  select.vs-input(
    :class='classes',
    :disabled='disabled',
    :aria-label='showDefaultValue ? defaultText : placeholder',
    :aria-describedby='errorId',
    :aria-disabled='disabled ? "true" : "false"',
    :aria-invalid='error ? "true" : "false"',
    :aria-required='!!errorId',
    :readonly='readonly',
    @change='$emit("input", $event)',
    @focus='updateFocus(true)',
    @blur='updateFocus(false)',
  )
    //- placeholder
    option(v-if='showPlaceholder', value='', disabled, selected) {{hideLabel ? placeholder : null}}
    option(v-if='defaultValue', :value='defaultValue') {{defaultText}}

    //- grouped options
    template(v-if='grouped')
      template(v-if='keyProperty && valueProperty')
        optgroup(v-for='(group, key) in groupedOptions', :key='key', :label='key')
          option(v-for='option in group', :selected='option[keyProperty] == value', :value='option[keyProperty]') {{option[valueProperty]}}
      template(v-else)
        optgroup(v-for='(group, key) in groupedOptions', :key='key', :label='key')
          option(v-for='option in group', :selected='option.key == value', :value='option.key') {{option.value}}

    //- key value options
    template(v-else-if='keyValue')
      option(v-for='(option, key) in options', :selected='key == value', :value='key') {{option}}
    template(v-else-if='keyProperty && valueProperty')
      option(v-for='option in options', :selected='option[keyProperty] == value', :value='option[keyProperty]') {{option[valueProperty]}}

    //- array options
    template(v-else)
      option(v-for='option in options', :selected='option == value', :value='option') {{option}}
</template>









